// extracted by mini-css-extract-plugin
export var createdDate = "_jz-1";
export var divider = "_jz-2";
export var headerDivider = "_jz-3";
export var messagesCard = "_jz-0";
export var messagesContainer = "_jz-6";
export var messagesContainerWrapper = "_jz-4";
export var showLeftPanelButton = "_jz-8";
export var topButtons = "_jz-7";
export var withPadding = "_jz-5";